/**
 * LandingHero - Modern hero section for landing page
 * Hero section
 */
import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n';

const LandingHero = () => {
  const { t } = useTranslation();
  
  return (
    <section 
      className="flex flex-col lg:flex-row items-center justify-between px-[5%] lg:px-[10%] pt-32 pb-16 lg:pt-36 lg:pb-20 bg-white dark:bg-background min-h-[80vh]"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      {/* Left Content */}
      <div className="flex-1 lg:pr-12 text-center lg:text-left mb-10 lg:mb-0">
        <h1 
          className="text-4xl sm:text-5xl lg:text-[3.5rem] font-bold mb-5 leading-tight"
          style={{ color: '#0052cc' }}
        >
          {t('landing.heroTitle')}
        </h1>
        <p className="text-lg lg:text-xl text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
          {t('notices.heroSubtitle')}
        </p>
        
        {/* Additional Content */}
        <h2 className="text-xl lg:text-2xl font-semibold text-gray-800 dark:text-white mb-4">
          {t('landing.yourWorldConnected')}
        </h2>
        <p className="text-base lg:text-lg text-gray-600 dark:text-gray-300 mb-4 leading-relaxed">
          {t('landing.experienceTheFuture')}{' '}
          <a 
            href="https://parachpay.com" 
            className="font-semibold hover:underline"
            style={{ color: '#0052cc' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            ParachPay
          </a>
          . {t('landing.heroDescription1')}
        </p>
        <p className="text-base lg:text-lg text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
          {t('landing.heroDescription2')}
        </p>
        
        <Link 
          to="/register"
          className="inline-block px-9 py-4 text-white font-bold text-lg rounded-lg transition-all duration-200 hover:scale-105 hover:shadow-lg"
          style={{ background: '#0052cc' }}
          data-testid="hero-cta-btn"
        >
          {t('landing.startTransacting')}
        </Link>
      </div>

      {/* Right Hero Image */}
      <div className="flex-1 flex justify-center lg:justify-end">
        <div className="relative w-full max-w-lg lg:max-w-xl">
          {/* Decorative background gradient */}
          <div 
            className="absolute -inset-4 bg-gradient-to-br from-blue-100 via-emerald-50 to-blue-50 dark:from-blue-900/20 dark:via-emerald-900/10 dark:to-blue-900/20 rounded-3xl blur-xl opacity-60"
            aria-hidden="true"
          />
          
          {/* Main Hero Image */}
          <img 
            src="https://customer-assets.emergentagent.com/wingman/b0033424-6b4b-45d2-80cb-8129b7f18625/attachments/e8dfbb26a6d0468496d93863146e41e9_photo.jpg" 
            alt="ParachPay - Global Payments Platform for seamless international money transfers and currency exchange"
            className="relative w-full h-auto rounded-2xl lg:rounded-3xl shadow-2xl object-contain"
            style={{ 
              boxShadow: '0 25px 50px -12px rgba(0, 82, 204, 0.25), 0 12px 24px -8px rgba(0, 0, 0, 0.1)'
            }}
            loading="eager"
            fetchpriority="high"
            decoding="async"
          />
          
          {/* Floating accent badge */}
          <div className="absolute -bottom-3 -left-3 lg:-bottom-4 lg:-left-4 bg-white dark:bg-slate-800 rounded-xl shadow-lg px-4 py-2 flex items-center gap-2">
            <div className="w-3 h-3 bg-emerald-500 rounded-full animate-pulse" />
            <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">{t('landing.currencies64')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingHero;
